export default __webpack_public_path__ + "077119988167820c2ff0e6367b1b1613.png";